var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportOutlineDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_11212",
    "data-name": "Grupo 11212",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17947",
    "data-name": "Ret\\xE2ngulo 17947",
    width: 20,
    height: 20,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11208",
    "data-name": "Grupo 11208",
    transform: "translate(1.989 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12691",
    "data-name": "Caminho 12691",
    d: "M604.8,165.278h6.669a.542.542,0,0,0,0-1.055H604.8a.542.542,0,0,0,0,1.055Z",
    transform: "translate(-601.282 -156.806)",
    fill: "#455079",
    stroke: "#455079",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12692",
    "data-name": "Caminho 12692",
    d: "M604.858,169.09h6.525a.527.527,0,0,0,0-1.054h-6.525a.527.527,0,0,0,0,1.054Z",
    transform: "translate(-601.268 -157.759)",
    fill: "#455079",
    stroke: "#455079",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12693",
    "data-name": "Caminho 12693",
    d: "M610.7,171.279h-8.876a.525.525,0,0,1-.525-.525V159.641h3.689a.526.526,0,0,0,.525-.525v-3.729h6.856a.56.56,0,0,1,.563.525V163.4a.525.525,0,1,0,1.05,0v-7.481a1.611,1.611,0,0,0-1.61-1.582h-7.383a.528.528,0,0,0-.375.156l-4.221,4.254a.528.528,0,0,0-.15.375v11.633a1.584,1.584,0,0,0,1.582,1.582H610.7a.527.527,0,0,0,0-1.054Zm-6.239-15.137v2.446H602.04Z",
    transform: "translate(-600.247 -154.333)",
    fill: "#455079",
    stroke: "#455079",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12694",
    "data-name": "Caminho 12694",
    d: "M619.631,172.194h0l-.225-.221a.364.364,0,0,0-.261-.108.369.369,0,0,0-.264.108l-1.425,1.425v-3.251a.525.525,0,0,0-.525-.525h0a.527.527,0,0,0-.525.525v3.268l-1.432-1.438a.365.365,0,0,0-.517,0h0l-.22.221a.37.37,0,0,0,0,.523h0l2.437,2.437a.376.376,0,0,0,.525,0l0,0,2.437-2.437A.371.371,0,0,0,619.631,172.194Z",
    transform: "translate(-603.716 -158.155)",
    fill: "#455079",
    stroke: "#455079",
    strokeWidth: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportOutlineDark);
export default __webpack_public_path__ + "static/media/report-outline-dark.141ca34ca57e7e2cc1150b4cc0364d31.svg";
export { ForwardRef as ReactComponent };